export const FirebaseConfig = {
	"projectId": "dala-kuha",
	"appId": "1:260419806157:web:f565a0b82ac3f44a201a84",
	"databaseURL": "https://dala-kuha-default-rtdb.asia-southeast1.firebasedatabase.app",
	"storageBucket": "dala-kuha.firebasestorage.app",
	"apiKey": "AIzaSyDdCviEaWwnQHxpgjxSTmf13enkxCXMMsk",
	"authDomain": "dala-kuha.firebaseapp.com",
	"messagingSenderId": "260419806157",
	"measurementId": "G-1TK53TPHD6"
};